import {createContext} from 'react';
import {RouterStore} from 'mobx-router';
import {ChatViewStore} from '../chat/chat-view-store';
import {ApiRepository} from './api-repository';
import {LabelStore} from './label-store';
import {UserStore} from '../user/user-store';
import {TeamResultsStore} from '../dashboard/team-results-store';
import {QuestionsStore} from '../questions/questions-store';
import {CompanyPageStore} from '../company/company-page-store';
import {PrivacyPolicyViewStore} from '../privacypolicy/privacy-policy-view-store';
import {SessionStore} from '../user/session-store';
import {SessionRepository} from '../user/session-repository';
import {LoginViewStore} from '../user/login-view-store';
import {PushNotificationStore} from '../user/push-notification-store';
import {OnboardingStore} from '../dashboard/onboarding-store';
import {StationStore} from '../station/station-store';
import {CompanySignUpStore} from '../signup/company-sign-up-store';
import {FeedbackStore} from '../feedback/feedback-store';
import {AzureSsoStore} from './azure-sso-store';
import {MentorStore} from '../mentor/mentor-store';
import {MyResultsStore} from '../dashboard/my-results-store';
import {CompanyDeleteStore} from '../signup/company-delete-store';
import {CategoriesStore} from '../categories/categories-store';

export class RootStore {
    router: RouterStore<RootStore> = new RouterStore<RootStore>(this);
    sessionRepository = new SessionRepository();
    apiRepository = new ApiRepository(this.sessionRepository);
    azureSsoStore = new AzureSsoStore(this.apiRepository);
    sessionStore = new SessionStore(this.sessionRepository, this.apiRepository, this.azureSsoStore);
    userStore = new UserStore(this.apiRepository, this.sessionStore);
    labelStore = new LabelStore(this.userStore);
    pushNotificationsStore = new PushNotificationStore(this.apiRepository, this.userStore, this.router);
    loginViewStore = new LoginViewStore(this.sessionStore, this.userStore, this.router, this.labelStore, this.pushNotificationsStore);
    chatViewStore = new ChatViewStore(this.apiRepository, this.labelStore, this.userStore, this.sessionStore, this.router);
    stationStore = new StationStore(this.apiRepository, this.labelStore);
    mentorStore = new MentorStore(this.apiRepository, this.labelStore, this.userStore);
    categoriesStore = new CategoriesStore(this.apiRepository, this.labelStore, this.userStore);
    teamResultsStore = new TeamResultsStore(this.apiRepository, this.labelStore, this.userStore, this.categoriesStore, this.sessionStore, this.router);
    myResultsStore = new MyResultsStore(this.apiRepository, this.labelStore, this.userStore, this.router);
    questionStore = new QuestionsStore(this.apiRepository, this.userStore, this.labelStore);
    companyStore = new CompanyPageStore(this.apiRepository, this.userStore, this.sessionStore, this.labelStore);
    onboardingStore = new OnboardingStore(this.apiRepository, this.labelStore, this.userStore, this.categoriesStore, this.router);
    feedbackStore = new FeedbackStore(this.apiRepository, this.labelStore, this.userStore);
    privacyPolicyViewStore = new PrivacyPolicyViewStore(this.labelStore);
    companySignUpStore = new CompanySignUpStore(this.apiRepository, this.sessionStore, this.router, this.labelStore);
    companyDeleteStore = new CompanyDeleteStore(this.apiRepository, this.userStore, this.labelStore);
}

export const store = new RootStore();

export const StoreContext = createContext({} as RootStore);
export const StoreProvider = StoreContext.Provider;
